import React, { useRef, useState, useEffect } from "react";
import { Playable } from "@wix/wix-vod-player";
export const Player = _ref => {
  let {
    src,
    fallbackSrc,
    poster,
    onPlayerReady,
    onEnd,
    disableSeekForward
  } = _ref;
  const playerRef = useRef(null);
  const previousTimeRef = useRef(0);
  const [currentSrc, setCurrentSrc] = useState(src);
  const [hasTriedFallback, setHasTriedFallback] = useState(false);

  // Reset playerRef when source changes to allow re-initialization
  useEffect(() => {
    if (currentSrc !== src) {
      playerRef.current = null;
    }
  }, [currentSrc, src]);
  const onPlayableInit = player => {
    if (!playerRef.current) {
      player.initSettings({
        qualityEnabled: true,
        speedEnabled: true
      });

      // Handle errors and fallback to MP4 if available
      player.on == null || player.on("video-events/error", () => {
        if (fallbackSrc && !hasTriedFallback) {
          setHasTriedFallback(true);
          setCurrentSrc(fallbackSrc);
        }
      });
      if (disableSeekForward) {
        // Store the current time periodically
        const updatePreviousTime = () => {
          previousTimeRef.current = (player.getCurrentTime == null ? void 0 : player.getCurrentTime()) || 0;
        };

        // Update previous time every second
        const timeUpdateInterval = setInterval(updatePreviousTime, 1000);
        player.on == null || player.on("video-events/seek-in-progress", e => {
          var _e$detail;
          const currentTime = (player.getCurrentTime == null ? void 0 : player.getCurrentTime()) || 0;
          const seekTargetTime = (e == null || (_e$detail = e.detail) == null ? void 0 : _e$detail.time) || currentTime;

          // If seeking forward, seek back to previous position
          if (seekTargetTime > previousTimeRef.current) {
            console.log("Seeking forward prevented, seeking back to:", previousTimeRef.current);
            player.seekTo == null || player.seekTo(previousTimeRef.current);
          }
        });

        // Clean up interval when player is destroyed
        player.on == null || player.on("destroy", () => {
          clearInterval(timeUpdateInterval);
        });
      }
      onPlayerReady && onPlayerReady(player);
      playerRef.current = player;
    }
  };
  return /*#__PURE__*/React.createElement(Playable, {
    key: currentSrc // Force re-render when source changes (for fallback)
    ,
    src: currentSrc,
    onPlayableInit: onPlayableInit,
    coverUrl: poster,
    onEnd: onEnd
  });
};
//# sourceMappingURL=Player.js.map